export const ACCA = {
    name: "ACCA",
    features: [
        {
            title: 'Cooling Load Calculations',
            description: 'Full support for Manual J 8th Edition residential cooling loads including block, room, and peak loads, infiltration and ventilation loads, detailed exposure diversity analysis (AED), October cooling load calculations, and room CFM estimates.',
            image: require('@/assets/img/content/mj8-cooling.png'),
        },
        {
            title: 'October Cooling Load Analysis',
            description: 'The October cooling load analysis is performed automatically for all projects. October loads may exceed summer loads in cases with large amounts of south facing glass. If high October loads are detected these are then used for the project results.',
            image: require('@/assets/img/content/mj8-october.png'),
        },
        {
            title: 'AED Calculations and Graphs',
            description: 'Adequate Exposure Diversity is a key concept for proper fenestration loads calculations in Manual J, and it is automatically evaluated for every project. If required an Excursion amount will automatically be added to the load results. AED graphs are available for onscreen viewing and in the output reports.',
            image: require('@/assets/img/content/mj8-aed.png'),
        },
        {
            title: 'Heating Load Calculations',
            description: 'Residential heating loads are calculated according to the Manual J standard, including infiltration, mechanical ventilation, cold partitions, radiant floors, and duct and pipe loads.',
            image: require('@/assets/img/content/mj8-heating.png'),
        },
        {
            title: 'Design Review Step',
            description: 'The custom Review Step in both HeatCAD and LoopCAD provides a valuable tool for the critical review of the key data and settings in your project. Easy access to the settings is also available here, so making changes and re-evaluating the results is quick.',
            image: require('@/assets/img/content/mj8-review.png'),
        },
        {
            title: 'Warning Flags',
            description: 'Warning flags are raised whenever the design parameters stray outside of the normal values recommended by Manual J. As the designer you can then choose if and how to deal with the issues.',
            image: require('@/assets/img/content/mj8-warnings.png'),
        },
        {
            title: 'Clear and Compliant Reports',
            description: 'HeatCAD and LoopCAD provide clear, easy to read reports that match the formats specified in Manual J. The available reports include: <ul><li>Form J1</li><li>Load Summary</li><li>Load Report</li><li>AED Report</li></ul> To further assist with your design review, all Manual J Forms A through I are available and automatically completed.',
            image: require('@/assets/img/content/mj8-reports.png'),
        },
        {
            title: 'Infiltration Loads Based on a Target Envelope Leakage',
            description: 'Implementation of ACCA Technical Reference Note 2016-1 to assist with the easy calculation of Manual J infiltration loads based on the maximum allowable Air Changes per Hour (ACH) that may be specified by the relevant code or standard in your region.',
            image: require('@/assets/img/content/mj8-infiltration.png'),
        },
    ]
}
